import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

// Self-hosted fonts (Adaptr Human: Inter + JetBrains Mono).
import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";

import "./styles/tokens.css";
import "./styles/components.css";
import "./styles/responsive.css";
import App from "./App";
import { captureSessionFromHash } from "./lib/api";
import { initTheme } from "./lib/theme";
import { initAnalytics } from "./lib/analytics";

// Apply the saved theme (System/Light/Dark) before first paint to avoid a flash.
initTheme();

// Start anonymous analytics only if the user previously opted in (default off).
initAnalytics();

// Capture the WorkOS session handed back in the URL fragment before first render.
captureSessionFromHash();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
